import type { Component, Entity2D } from '../../odie';

import { CocoonBlockProps } from '../defs/block';
import { CocoonBlockView } from '../views/blocks/CocoonBlockView';

// types
//-----------------------------------------------------------------------------
export type CocoonBlockComponentOptions = {
  props: CocoonBlockProps;
};

/*
    cocoon block component
*/
export class CocoonBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockCocoon';

  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: CocoonBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: CocoonBlockComponentOptions): void {
    this.view = new CocoonBlockView({ ...options.props });
  }
}
